import { SkeletonCard, SkeletonChart, SkeletonTable } from "@/components/ui/Skeleton";

interface DashboardSkeletonProps {
  cards?: number;
  chart?: boolean;
  table?: boolean;
}

export function DashboardSkeleton({
  cards = 4,
  chart = true,
  table = true,
}: DashboardSkeletonProps) {
  return (
    <div className="space-y-6">
      <div className={`grid gap-4 grid-cols-2 sm:grid-cols-${Math.min(cards, 4)}`}>
        {Array.from({ length: cards }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
      {chart && <SkeletonChart />}
      {table && <SkeletonTable />}
    </div>
  );
}
